jQuery(document).ready(function(){
	jQuery('.home-product-cat .product_cat-tab .item').click(function(){
		jQuery('.home-product-cat .product_cat-tab').find(".active").removeClass('active');
		jQuery(this).addClass('active');
		var data_tab = jQuery(this).attr('data-tab');
		console.log(data_tab);
		jQuery('.home-product-cat .product_cat-content').find(".active").removeClass('active');
		jQuery('.'+data_tab).addClass('active');
	});
});